import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { connect } from 'react-redux'
import uuid from 'uuid'
import { compose } from 'recompose'

import { Modal } from 'containers/misc'
import { Table, Data } from 'components/layout/Table'
import { TasksEvidence } from 'components/sections/tasks'
import { Button } from 'components/misc'
import {
  residentialProjects as residentialProjectsLayout
} from 'constants/layout'
import { modal } from 'redux/modules/app'

const enhance = compose(connect(null, { modal }))

class ObservationsBlock extends Component {
  static propTypes = {
    modal: PropTypes.func.isRequired,
    observations: PropTypes.string,
    fileUrls: PropTypes.array
  }

  static defaultProps = {
    observations: '',
    fileUrls: []
  }

  key = uuid.v1()

  render() {
    const { fileUrls, observations } = this.props

    if (!observations && fileUrls.length === 0) {
      return null
    }

    return (
      <div>
        <Table ths={residentialProjectsLayout.observationsTable}>
          <Data>
            <tr>
              <td style={{ width: 200 }}>
                {fileUrls.length > 0
                  ? <Button
                      type="button"
                      intlKey="button.view"
                      link
                      onClick={() =>
                        this.props.modal(`modal-show-evidence-${this.key}`)}
                    >
                      View
                    </Button>
                  : '---'}
              </td>
              <td>
                {observations || '---'}
              </td>
            </tr>
          </Data>
        </Table>
        <Modal id={`modal-show-evidence-${this.key}`}>
          <TasksEvidence fileUrls={fileUrls} />
        </Modal>
      </div>
    )
  }
}

export default enhance(ObservationsBlock)
